export const APP_PAGE_ANCHOR = 'app'
export const APP_ENTRY_HREF = `#${APP_PAGE_ANCHOR}`
